export const NAMES = [
  { id: 'ggdad',   name: 'GG DAD',          slogan: 'Good Game. Good Night. Back to diapers.', base: 4812 },
  { id: 'naptime', name: 'NAPTIME ESPORTS', slogan: 'We queue when they sleep.',                base: 2104 },
  { id: 'midlife', name: 'MID-LIFE CRISIS', slogan: 'Mid lane. Mid 30s. Maximum effort.',       base: 3287 },
  { id: 'patched', name: 'PATCHED DADS',    slogan: 'Always one patch behind.',                  base: 1654 },
  { id: 'papa',    name: 'PAPA RANKS',      slogan: 'Push lane. Push stroller.',                 base: 1982 }
];
